import React from "react"
import styles from "./index.module.scss"

interface IDeleteRepository {
  onClick: () => void
  repoId: string
}

export const DeleteRepository: React.FC<IDeleteRepository> = ({repoId, onClick}) => {
  return (
    <div className={styles.Section}>
      <div className={styles.SubHeader}>
        Delete Repository
      </div>
      <div className={styles.SectionRow}>
        This operation is irreversible and could lead to serious consequences.
      </div>

      <div className={styles.SectionRow}>
        <button className={styles.WarningBtn} onClick={onClick}>
          Delete "{repoId}"
        </button>
      </div>
    </div>
  )
}
